import { InputHTMLAttributes } from "react";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
	id: string;
	value?: string;
	placeholder?: string;
	className?: string;
	label?: string;
	size?: "sm" | "md" | "lg";
	labelPlacement?: "inside" | "outside";
	isDisabled?: boolean;
	isReadonly?: boolean;
	inputEnd?: React.ReactNode;
	error?: boolean;
}

export const Input: React.FC<InputProps> = ({
	id = "",
	value = "",
	placeholder = "",
	className = "",
	label = "",
	size = "md",
	labelPlacement = "inside",
	isDisabled = false,
	isReadonly = false,
	inputEnd,
	onChange,
	error,
	...props
}) => {
	const sizePadding = {
		sm: "px-3 py-2 pt-7",
		md: "px-3 py-2 pt-6",
		lg: "px-3 py-2 pt-6 sm:pt-7",
	};

	const sizeText = {
		sm: "text-md",
		md: "text-sm",
		lg: "text-sm sm:text-md",
	};

	const topText = {
		sm: "text-md",
		md: "peer-placeholder-shown:top-[18px]",
		lg: `${window.innerWidth > 640 ? "peer-placeholder-shown:top-[21px]" : "peer-placeholder-shown:top-[18px]"}`,
	};

	return (
		<div className="relative">
			{placeholder ? (
				<>
					{label && (
						<label
							htmlFor={id}
							className={`select-none absolute top-2 left-3 text-gray-500 ${sizeText[size]}`}
						>
							{label}
						</label>
					)}
					<input
						id={id}
						value={value}
						onChange={onChange}
						className={`w-full rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500 ${sizePadding[size]} ${sizeText[size]} ${className}} `}
						placeholder={placeholder}
						disabled={isDisabled}
						readOnly={isReadonly}
						{...props}
					/>
					{inputEnd && <div className="absolute top-0 h-full right-0 flex items-center px-3">{inputEnd}</div>}
				</>
			) : (
				<>
					<div className="flex items-center justify-center relative">
						<input
							id={id}
							placeholder=""
							onChange={onChange}
							value={value}
							disabled={isDisabled}
							readOnly={isReadonly}
							className={`w-full rounded border focus:outline-none focus:ring-0 focus:ring-offset-2 ${
								error ? "border-red-500 focus:ring-offset-red-500/40 focus:ring-red-200" : "border-gray-300 focus:ring-offset-orange-500 focus:ring-orange-200"
							} ${sizePadding[size]} ${sizeText[size]} ${className} peer`}
							{...props}
						/>
						<label
							htmlFor={id}
							className={`absolute top-2 ${error ? "text-red-500 peer-focus:text-red-500" : "text-gray-500 peer-focus:text-orange-500"}  ${
								sizeText[size]
							} left-3 cursor-text peer-focus:${sizeText[size]} peer-focus:top-2 transition-all  ${topText[size]} peer-placeholder-shown:${
								sizeText[size]
							} overflow-hidden text-ellipsis whitespace-nowrap`}
						>
							{label}
						</label>
					</div>
				</>
			)}
		</div>
	);
};
